import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import httpClient from "../../utils/httpClient";

type RequestType = {
  isLoading: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  error: string | null;
};

const initialState: RequestType = {
  isLoading: false,
  data: null,
  error: "",
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteSku = createAsyncThunk<any, any>(
  "CTDBSkuDeleteSlice/deleteSku",
  async (requestDetails, thunkApi) => {
    try {
      const response = await httpClient.post("/db/product/sku", {
        ...requestDetails,
        Action: "deleteSku",
      });
      const successStatusCodes = [200, 201, 202];
      if (
        !successStatusCodes.includes(response.status) ||
        response.data.Status !== "success"
      ) {
        if (response.data.Status === "error") {
          return thunkApi.rejectWithValue({
            message: response.data.Message,
          });
        } else {
          return thunkApi.rejectWithValue({
            message: "Failed to delete SKU.",
          });
        }
      }
      return response.data;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.log("🚀 ~ error:", error);
      return thunkApi.rejectWithValue({
        message: "Failed to delete SKU.",
      });
    }
  }
);

const CTDBSkuDeleteSlice = createSlice({
  name: "CTDBSkuDeleteSlice",
  initialState,
  reducers: {
    resetDeleteSkuState: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteSku.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.data = null;
      })
      .addCase(
        deleteSku.fulfilled,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (state, action: PayloadAction<any>) => {
          if (action.payload.Status === "success") {
            state.isLoading = false;
            state.data = action.payload.Data;
            state.error = null;
          } else if (action.payload.Status === "error") {
            state.isLoading = false;
            state.data = null;
            state.error = action.payload.message;
          }
        }
      )
      .addCase(
        deleteSku.rejected,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.data = null;
          state.error = action.payload.message;
        }
      );
  },
});

export const { resetDeleteSkuState } = CTDBSkuDeleteSlice.actions;

export default CTDBSkuDeleteSlice.reducer;
